import React from 'react';
import PropTypes from 'prop-types';

/**
 * A card component displaying the user's postpaid account information
 * 
 * @param {Object} props - Component props
 * @param {string} props.status - Account status (Active, Pending, etc.)
 * @param {string} props.billingPeriod - Current billing period
 */
const PostpaidAccountCard = ({ status = 'Active', billingPeriod }) => {
  return (
    <div className="card bg-white shadow-md rounded-lg p-6">
      <h2 className="text-gray-500 text-sm font-semibold uppercase mb-2 font-mont">Account Information</h2>
      <div className="flex items-baseline mb-4">
        <span className="text-xl font-bold text-hooray-dark-text font-mont">
          Postpaid Account
        </span>
      </div>
      <div className="mt-2 space-y-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Status:</span>
          <span className={`font-semibold ${status === 'Active' ? 'text-green-600' : 'text-yellow-600'}`}>
            {status}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Current Period:</span>
          <span className="font-semibold">{billingPeriod || 'Not available'}</span>
        </div>
      </div>
      <div className="mt-4 text-sm text-gray-600">
        Your electricity usage is billed on a postpaid basis. Payments are handled directly by your property manager.
      </div>
    </div>
  );
};

PostpaidAccountCard.propTypes = {
  status: PropTypes.string,
  billingPeriod: PropTypes.string
};

export default PostpaidAccountCard; 